type ReturnType = string | ArrayBuffer | null | undefined;
export type ReadCSVFileFn = (file: File) => Promise<ReturnType>;

export const readCSVFile: ReadCSVFileFn = (file) => {
  return new Promise<ReturnType>((resolve) => {
    const fileReader = new FileReader();
    if (file) {
      fileReader.onload = (event) => {
        const text = event?.target?.result;
        resolve(text);
      };
      fileReader.readAsText(file);
    } else {
      resolve('');
    }
  });
};

export const csvFileToArray = (value: string | undefined | null | '') => {
  if (value) {
    const rows = value.split('\n');
    const csvHeader = rows[0].replaceAll('\r', '').split(',');
    const dataRows = rows.map((r) => r.replaceAll('\r', '')).filter((r, i) => i !== 0 && r.trim() !== '');

    const array = dataRows
      .map((i) => {
        const values = i.split(',');
        const obj = csvHeader.reduce<Record<string, any>>((object, header, index) => {
          const key = header.trim();
          if (values[index].includes('\r')) {
            object[key] = values[index].split('\r')[0];
          } else {
            object[key] = values[index];
          }
          return object;
        }, {});
        return obj;
      })
      .filter((arr) => arr !== undefined);
    return array;
  }
  return [];
};
